import useSWR from "swr";
import axios from "axios";

function useProjects({ status, startDate, endDate, search, page, perPage, sortField, sortOrder }) {
  return useSWR([
    `${process.env.REACT_APP_API_URL}/projects`,
    status, startDate, endDate, search, page, perPage, sortField, sortOrder
  ], async ([url, status, startDate, endDate, search, page, perPage, sortField, sortOrder]) => {
    const params = new URLSearchParams();

    if (status) params.append('status', status);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (search) params.append('search', search);
    if (page) params.append('page', page);
    if (perPage) params.append('perPage', perPage);
    if (sortField) params.append('sortField', sortField);
    if (sortOrder) params.append('sortOrder', sortOrder);

    const { data: { projects, count } } = await axios.get(`${url}?${params.toString()}`);

    return { projects, count };
  });
}

export default useProjects;
